module["exports"] = [
  "ge",
  "com",
  "net",
  "org",
  "com.ge",
  "org.ge"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/internet/domain_suffix.js
// module id = 873
// module chunks = 0